import React from 'react'
import { useLocation } from 'react-router-dom'
import ModernSidebar from './ModernSidebar'
import ModernHeader from './ModernHeader'

interface ModernLayoutProps {
  children: React.ReactNode
}

export default function ModernLayout({ children }: ModernLayoutProps) {
  const location = useLocation()

  // Detectar se estamos na página do PDV
  const isPDVPage = location.pathname === '/vendas/pdv'

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Sidebar */}
      <ModernSidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header - Esconder no PDV */}
        {!isPDVPage && <ModernHeader />}

        {/* Content Area */}
        <main className="flex-1 overflow-hidden bg-gradient-to-br from-background to-background/95">
          <div className="h-full">
            <div className="animate-fade-in h-full">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}